var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
//
import * as HttpConf from "./HttpConf";
import * as CONST from "@utils/Const";
function encodeUrlPath(url) {
    var pos = url.indexOf("?");
    if (pos < 0) {
        // not found
        pos = url.length;
    }
    var spath = url.substring(0, pos);
    var params = url.substring(pos + 1, url.length);
    var psp = spath.split("/");
    var path = "";
    for (var i = 0; i < psp.length; i++) {
        if (psp[i].length <= 0)
            continue;
        path = path + "/" + encodeURIComponent(psp[i]);
    }
    var sp = params.split("&");
    for (var i = 0; i < sp.length; i++) {
        if (sp[i].length <= 0)
            continue;
        if (i === 0) {
            path = path + "?";
        }
        else {
            path = path + "&";
        }
        var p = sp[i].indexOf("=");
        if (p < 0) {
            path = path + encodeURIComponent(sp[i]);
        }
        else {
            path = path + sp[i].substring(0, p) + "=" + encodeURIComponent(sp[i].substring(p + 1, sp[i].length));
        }
    }
    return path;
}
/**
 * @brief useAync hook : 비동기 HTTP API 호출 - Action 없이 작동
 * @param param0 httpMethod:<string>: GET|POST|PUT ..
 * @param param1 appPath:<string>: API App Path ..
 * @param param2 appQuery:<json>: API App params ..
 * @returns
 */
export function PromiseHttp({ httpMethod, appPath, appQuery, userToken, onUploadProgress }) {
    return __awaiter(this, void 0, void 0, function* () {
        return Http([], { httpMethod, appPath, appQuery, userToken, onUploadProgress });
    });
}
/**
 * @brief useAync hook : 비동기 HTTP API 호출 - Action에 의해 작동
 * @param param0 httpMethod:<string>: GET|POST|PUT ..
 * @param param1 appPath:<string>: API App Path ..
 * @param param2 appQuery:<json>: API App params ..
 * @returns
 */
export function Http(args, { httpMethod, appPath, appQuery, userToken, onUploadProgress }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __awaiter(this, void 0, void 0, function* () {
        let response;
        let httpResp = {
            status: 500,
            codeNum: CONST.API_999,
            data: "",
            body: "",
            errorList: [{ field: `cntError`, msg: CONST.ERROR_SERVER_MSG }],
        };
        let appMethod = httpMethod === "POST" ? "POST" : httpMethod === "PUT" ? "PUT" : httpMethod === "GET" ? "GET" : "DELETE";
        if (httpMethod == "POST") {
            appMethod = "POST";
        }
        else if (httpMethod == "POSTF") {
            appMethod = "POSTF";
        }
        else if (httpMethod == "PUT") {
            appMethod = "PUT";
        }
        else if (httpMethod == "GET") {
            appMethod = "GET";
        }
        else if (httpMethod == "GETF") {
            appMethod = "GETF";
        }
        else if (httpMethod == "DELETE") {
            appMethod = "DELETE";
        }
        else if (httpMethod == "DELETEDATA") {
            appMethod = "DELETEDATA";
        }
        else {
            return "Unknonw API Method!!!!";
        }
        appPath = encodeUrlPath(appPath);
        try {
            if (appMethod == "POST") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    data: appQuery,
                });
            }
            else if (appMethod == "POSTF") {
                response = yield axios({
                    headers: { Authorization: userToken, "Content-Type": "multipart/form-data" },
                    method: "POST",
                    url: HttpConf.API_BASE + appPath,
                    data: appQuery,
                });
            }
            else if (appMethod == "PUT") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    data: appQuery,
                });
            }
            else if (appMethod == "DELETE") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    params: appQuery,
                });
            }
            else if (appMethod == "GET") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    params: appQuery,
                });
            }
            httpResp.status = yield response.status;
            httpResp.codeNum = Object.prototype.hasOwnProperty.call(response.data, "codeNum")
                ? yield response.data.codeNum
                : 200;
            httpResp.errorList = Object.prototype.hasOwnProperty.call(httpResp.data, "errorList")
                ? yield response.data.errorList
                : [{ msg: "" }];
            httpResp.data = yield response.data;
            httpResp.body = Object.prototype.hasOwnProperty.call(httpResp.data, "list")
                ? response.data.list
                : response.data.data;
            return httpResp;
        }
        catch (err) {
            const r = err === null || err === void 0 ? void 0 : err.response;
            const d = (_a = r === null || r === void 0 ? void 0 : r.data) !== null && _a !== void 0 ? _a : {};
            // 여러 형태의 에러 응답에서 message만 안전하게 추출
            const message = (_h = (_g = (_e = (_d = (_b = d === null || d === void 0 ? void 0 : d.message) !== null && _b !== void 0 ? _b : (_c = d === null || d === void 0 ? void 0 : d.body) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : d === null || d === void 0 ? void 0 : d.errorMessage) !== null && _e !== void 0 ? _e : (_f = d === null || d === void 0 ? void 0 : d.error) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : err === null || err === void 0 ? void 0 : err.message) !== null && _h !== void 0 ? _h : "Undefined error!";
            httpResp.status = (_j = r === null || r === void 0 ? void 0 : r.status) !== null && _j !== void 0 ? _j : 500;
            httpResp.codeNum =
                typeof (d === null || d === void 0 ? void 0 : d.codeNum) === "number" ? d.codeNum : CONST.API_999;
            // 참고용 errorList는 있으면 그대로, 없으면 메시지 하나만
            httpResp.errorList = Array.isArray(d === null || d === void 0 ? void 0 : d.errorList)
                ? d.errorList
                : [{ msg: message }];
            // 원본 응답은 data에 유지
            httpResp.data = d;
            // 🔴 호출부가 항상 data.body.message 로 읽을 수 있도록 보장
            httpResp.body = { message };
            return httpResp;
        }
        finally {
            return httpResp;
        }
    });
}
